module.exports = __webpack_public_path__ + "static/media/44.10feadd3.png";